import { FC } from 'react';

interface ChartHeaderProps {
  viewWindow: {
    start: number;
    end: number;
  };
  totalMonths: number;
  monthsToShow: number;
  onEarlierClick: () => void;
  onLaterClick: () => void;
}

/**
 * Reusable chart header component that displays navigation info and buttons
 * Used across all financial charts to provide consistent UI/UX
 */
const ChartHeader: FC<ChartHeaderProps> = ({ 
  viewWindow, 
  totalMonths,
  monthsToShow: _,
  onEarlierClick, 
  onLaterClick 
}) => {
  // Calculate the number of months currently shown
  const visibleMonthsCount = viewWindow.end - viewWindow.start;

  return (
    <div className="mb-2 flex items-center justify-between">
      <div className="text-sm text-slate-700">
        <span className="font-semibold">{visibleMonthsCount}</span> of <span className="font-semibold">{totalMonths}</span> months shown
        {totalMonths < 24 && <span className="ml-1 text-amber-500 text-xs">(Limited data available)</span>}
      </div>
      
      <div className="flex items-center gap-2">
        <button 
          className="text-xs px-2 py-0.5 rounded bg-slate-100 hover:bg-slate-200 text-slate-700 transition-colors"
          onClick={onEarlierClick}
        >
          ← Earlier
        </button>
        
        <button 
          className="text-xs px-2 py-0.5 rounded bg-slate-100 hover:bg-slate-200 text-slate-700 transition-colors"
          onClick={onLaterClick}
        >
          Later →
        </button>
      </div>
    </div>
  );
};

export default ChartHeader; 